export type PlanStatus = "active" | "inactive"

export type APIPlan = {
  id: string
  providerId: string
  name: string
  description: string
  status: PlanStatus
  price: number
  createdAt: string
  updatedAt: string
}

export type Plan = {
  id: string
  providerId: string
  providerName: string
  name: string
  description: string
  status: PlanStatus
  price: number
  createdAt: Date
  updatedAt: Date
}

export type NewPlan = {
  name: string
  description: string
  status: PlanStatus
  price: number
}

export type UpdatePlan = {
  name?: string
  description?: string
  status?: PlanStatus
  price?: number
}

export const parseAPIPlan = (apiPlan: APIPlan): Plan => ({
  id: apiPlan.id,
  providerId: apiPlan.providerId,
  providerName: "", // This will need to be populated from provider data
  name: apiPlan.name,
  description: apiPlan.description,
  status: apiPlan.status,
  price: apiPlan.price,
  createdAt: new Date(apiPlan.createdAt),
  updatedAt: new Date(apiPlan.updatedAt)
}) 